export function findScreenByName(screenName, data) {
    if (!data || !data.groups) return null;

    for (let groupIndex = 0; groupIndex < data.groups.length; groupIndex++) {
        const group = data.groups[groupIndex];
        for (let screenIndex = 0; screenIndex < group.screens.length; screenIndex++) {
            if (group.screens[screenIndex].name === screenName) {
                return { groupIndex, screenIndex };
            }
        }
    }
    return null;
}

export function evaluateClause(clause, answersRef) {
    const { screenName, variableName, operator, value } = clause;
    const answers = answersRef.current;

    console.log('evaluateClause: ', clause);
    console.log('answers: ', answers);


    let answer = answers.get(screenName);
    if (!answer && variableName !== screenName) {
        answer = answers.get(variableName);
    }

    if (!answer) {
        console.log(`Condition check: No answer found for ${screenName}/${variableName}`);
        return false;
    }

    const answerValue = answer.value;
    console.log(`Condition check: ${variableName} "${answerValue}" ${operator} "${value}"`);

    switch (operator) {
        case 'equals':
            return answerValue === value;
        case 'not_equals':
            return answerValue !== value;
        case 'contains':
            return answerValue && answerValue.includes(value);
        case 'not_contains':
            return !answerValue || !answerValue.includes(value);
        case 'greater_than':
            return parseFloat(answerValue) > parseFloat(value);
        case 'less_than':
            return parseFloat(answerValue) < parseFloat(value);
        default:
            console.warn(`Unknown operator: ${operator}`);
            return false;
    }
}

export function evaluateCondition(condition, answersRef) {

    console.log('evaluateCondition: ', condition);
    console.log('answersRef: ', answersRef);

    if (Array.isArray(condition.clauses) && condition.clauses.length) {

        condition.clauses.forEach(clause => {
            console.log('clause: ', clause);
            console.log('evaluateClause result: ', evaluateClause(clause, answersRef));
        });

        let res = condition.clauses.every(clause => evaluateClause(clause, answersRef));

        console.log('evaluateCondition result: ', res);

        return res;
    }

    return evaluateClause(condition, answersRef);
}

export function getNextScreenFromTransition(currentScreen, answersRef) {
    if (!currentScreen || !currentScreen.transition) {
        return null;
    }

    const transition = currentScreen.transition;

    if (transition.type === 'direct') {
        return transition.nextScreen || null;
    }

    if (transition.type === 'conditional') {
        if (transition.conditions && Array.isArray(transition.conditions)) {
            for (const condition of transition.conditions) {
                if (evaluateCondition(condition, answersRef)) {
                    console.log(`conditional transition: value ${condition.value} targetScreen: ${condition.targetScreen}`);
                    return condition.targetScreen;
                }
            }
        }

        if (transition.defaultScreen) {
            console.log(`No conditions matched, using default: ${transition.defaultScreen}`);
            return transition.defaultScreen;
        }

        return null;
    }

    return null;
}
